import { gql } from "apollo-angular";

export const  DISCLAIMER_ITEM_FIELDS = gql`
  fragment DISCLAIMER_ITEM_FIELDS on DisclaimerItem {
    title
    disclaimer {
      json
    }
  }`;
